// @flow
import OrgsListTableCellPresence from './OrgsListTableCellPresence';

export default OrgsListTableCellPresence;
